<template>
  <div :style="{ backgroundImage: `url(${orgBackground})`}">
    <div
      class="affirmMessage"
      style="background: #f7f6f9; padding-bottom: 1.1rem"
    >
      <div style="margin-bottom:40px">
        <div v-if="showOpen" class="Header">
          <span>i</span>
          <p>若页面点击无效，请移步微信小程序出单。</p>
        </div>
        <div class="li-content">
          <div
            class="border-style"
            @click="clickShows('showOrder', 'downImgOrder')"
          >
            <mt-cell class="title-weight" title="订单信息">
              <img :src="downImgOrder" alt="">
            </mt-cell>
          </div>
          <div v-show="showOrder" class="info-content">
            <div class="info-li">
              <a>订单信息</a>
              <p>{{ orderNo }}</p>
            </div>
            <div v-if="showJQ" class="info-li">
              <a>交强险投保单号</a>
              <p>{{ JQOderNo }}</p>
            </div>
            <div v-if="showJQ && orderStatus === '4'" class="info-li">
              <a>交强险保单号</a>
              <p>{{ JQPolicyNo }}</p>
            </div>
            <div v-if="showSY" class="info-li">
              <a>商业险投保单号</a>
              <p>{{ SYOderNo }}</p>
            </div>
            <div v-if="showSY && orderStatus === '4'" class="info-li">
              <a>商业险保单号</a>
              <p>{{ SYPolicyNo }}</p>
            </div>
            <div v-if="neworderPolicyList.length > 0">
              <div v-for="(item, i) in neworderPolicyList" :key="i">
                <div>
                  <div class="info-li">
                    <a>{{ item.typeName }}投保单号</a>
                    <p>{{ item.insureNo }}</p>
                  </div>
                  <div v-if="orderStatus === '4'" class="info-li">
                    <a>{{ item.typeName }}保单号</a>
                    <p>{{ item.policyNo }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="li-content">
          <div class="border-style" @click="clickShows('showFee', 'downImgFee')">
            <mt-cell class="title-weight" title="保费合计">
              <span>¥{{ orderAmount }}</span>
              <img :src="downImgFee" alt="">
            </mt-cell>
          </div>
          <div v-show="showFee">
            <div v-if="showJQ" class="total-content">
              <div class="info-li">
                <h3>交强险(含车船税)</h3>
                <div class="info-li">
                  <p>合计:</p>
                  <p style="color: #ff9406; font-weight: 600">
                    ¥{{ planFeeCi }}
                  </p>
                </div>
              </div>
              <div class="info-li">
                <a>交强险保险</a>
                <p>¥{{ JQInfo }}</p>
              </div>
              <div class="info-li">
                <a>车船税({{ taxRelifFlag }})</a>
                <p>¥{{ planFeeCs }}</p>
              </div>
              <div class="info-li">
                <a>保险日期</a>
                <p>{{ JQDateS }} {{ JQHourS }}时至{{ JQDateE }} {{ JQHourE }}时</p>
              </div>
            </div>
            <div v-if="showSY" class="total-content">
              <div class="info-li">
                <h3>商业险</h3>
                <div class="info-li">
                  <p>合计:</p>
                  <p style="color: #ff9406; font-weight: 600">
                    ¥{{ planFee }}
                  </p>
                </div>
              </div>
              <div
                v-for="(item, index) in bxInfo"
                id="info-lis"
                :key="index"
                class="info-li"
              >
                <a>{{ item.kindName }}</a>
                <p class="p">
                  {{ item.amountNumber }}
                </p>
                <p>¥{{ item.premium }}</p>
              </div>
              <div
                v-if="vehicleInfo.insuredArea.indexOf('246') != 0"
                class="info-li"
              >
                <a>商业险折扣</a>
                <p style="color: #ff9406">
                  {{ discount }}
                </p>
              </div>
              <div class="info-li">
                <a>保险日期</a>
                <p>{{ SYDateS }} {{ SYHourS }}时至{{ SYDateE }} {{ SYHourE }}时</p>
              </div>
            </div>
            <!-- 线下产品 -->
            <div v-if="showXianXia">
              <div
                v-for="(item, index) in carPolicySubInfoList"
                :key="index"
                class="total-content"
              >
                <div class="info-li">
                  <h3>{{ item.productName }}</h3>
                </div>
                <div id="info-li" class="info-li">
                  <a>方案</a>
                  <p>{{ item.planName }}</p>
                </div>
                <div class="info-li">
                  <a>保额</a>
                  <p>¥{{ item.sumAmount }}</p>
                </div>
                <div class="info-li">
                  <a>保费</a>
                  <p>¥{{ item.sumPremium }}</p>
                </div>
              </div>
            </div>
            <!-- 线上产品 -->
            <div v-if="showXianShang">
              <div
                v-for="(item, index) in attachRiskList"
                :key="index"
                class="total-content"
              >
                <div class="info-li">
                  <h3>{{ item.productName }}</h3>
                </div>
                <div id="info-li" class="info-li">
                  <a>方案</a>
                  <p>{{ item.planName }}</p>
                </div>
                <div class="info-li">
                  <a>保额</a>
                  <p>¥{{ item.sumAmount }}</p>
                </div>
                <div class="info-li">
                  <a>保费</a>
                  <p>¥{{ item.sumPremium }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="li-content">
          <div class="border-style" @click="clickShows('showCar', 'downImgCar')">
            <mt-cell class="title-weight" title="车辆信息">
              <img :src="downImgCar" alt="">
            </mt-cell>
          </div>
          <div v-show="showCar" class="info-content">
            <div class="info-li">
              <a>车牌号</a>
              <p>{{ vehicleInfo.licenseNo }}</p>
            </div>
            <div class="info-li">
              <a>车架号/VIN码</a>
              <p>{{ vehicleInfo.vINNo }}</p>
            </div>
            <div class="info-li">
              <a>品牌型号</a>
              <p>{{ vehicleInfo.brandName }}</p>
            </div>
            <div class="info-li">
              <a>发动机号</a>
              <p>{{ vehicleInfo.engineNo }}</p>
            </div>
            <div class="info-li">
              <a>注册日期</a>
              <p>{{ vehicleInfo.enrollDate }}</p>
            </div>
          </div>
        </div>

        <div class="li-content">
          <div class="border-style">
            <mt-cell class="title-weight" title="关系人信息" />
          </div>
          <div class="ownerInfo-content">
            <div class="info-li" @click="clickShows('hideArea1', 'downImgPer1')">
              <a>车主</a>
              <p>{{ carOwnerInfo.carOwner }}</p>
              <img :src="downImgPer1" alt="">
            </div>
            <div v-show="hideArea1">
              <div class="info-li">
                <a>证件类型</a>
                <p>{{ carOwnerInfo.ownerIdentifyType }}</p>
              </div>
              <div class="info-li">
                <a>证件号码</a>
                <p>{{ carOwnerInfo.ownerIdentifyNumber }}</p>
              </div>
              <div class="info-li">
                <a>投保地区</a>
                <p>{{ vehicleInfo.insuredAreaCN }}</p>
              </div>
            </div>
          </div>
          <div class="ownerInfo-content">
            <div class="info-li" @click="clickShows('hideArea2', 'downImgPer2')">
              <a>投保人</a>
              <p>{{ applicantIn.insuredName }}</p>
              <img :src="downImgPer2" alt="">
            </div>
            <div v-show="hideArea2">
              <div class="info-li">
                <a>证件类型</a>
                <p>{{ applicantIn.insuredIdentity }}</p>
              </div>
              <div class="info-li">
                <a>证件号码</a>
                <p>{{ applicantIn.identifyNumber }}</p>
              </div>
              <div class="info-li">
                <a>证件有效期</a>
                <p>{{ applicantIn.validDate }}</p>
              </div>
              <div class="info-li">
                <a>手机号码</a>
                <p>{{ applicantIn.mobile }}</p>
              </div>
              <div class="info-li">
                <a>电子邮箱</a>
                <p>{{ applicantIn.email }}</p>
              </div>
              <div v-show="applicantIn.linkerName" class="info-li">
                <a>联系人名称</a>
                <p>{{ applicantIn.linkerName }}</p>
              </div>
            </div>
          </div>
          <div class="ownerInfo-content">
            <div class="info-li" @click="clickShows('hideArea3', 'downImgPer3')">
              <a>被保人</a>
              <p>{{ recognizeeIn.insuredName }}</p>
              <img :src="downImgPer3" alt="">
            </div>
            <div v-show="hideArea3">
              <div class="info-li">
                <a>证件类型</a>
                <p>{{ recognizeeIn.insuredIdentity }}</p>
              </div>
              <div class="info-li">
                <a>证件号码</a>
                <p>{{ recognizeeIn.identifyNumber }}</p>
              </div>
              <div class="info-li">
                <a>证件有效期</a>
                <p>{{ recognizeeIn.validDate }}</p>
              </div>
              <div class="info-li">
                <a>手机号码</a>
                <p>{{ recognizeeIn.mobile }}</p>
              </div>
              <div class="info-li">
                <a>电子邮箱</a>
                <p>{{ recognizeeIn.email }}</p>
              </div>
              <div v-show="recognizeeIn.linkerName" class="info-li">
                <a>联系人名称</a>
                <p>{{ recognizeeIn.linkerName }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="li-content">
          <div class="border-style" @click="clickShows('showEngin', 'enginShow')">
            <mt-cell class="title-weight" title="特别约定">
              <img :src="enginShow" alt="">
            </mt-cell>
          </div>
          <div
            v-show="showEngin"
            class="show-chosen-img"
          >
            <h3 v-if="engageList.length>0">
              交强险特约
            </h3>
            <div
              v-for="(item, key) in engageList"
              :key="key"
              class="choose-img-content"
              style="font-size: .14rem;margin-left:.1rem;padding-bottom:.15rem"
            >
              <div style="margin-bottom:.1rem">
                {{ item.clauseName }}
              </div>
              <div style="color:#888;">
                {{ item.clauses }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="hasImglist" class="li-content">
          <div class="border-style" @click="clickShows('showPic', 'downImgPic')">
            <mt-cell class="title-weight" title="影像信息">
              <img :src="downImgPic" alt="">
            </mt-cell>
          </div>
          <div
            v-for="(item, key) in tabsContent"
            v-show="item.state && showPic"
            :key="key"
            class="show-chosen-img"
          >
            <h3>{{ item.text }}</h3>
            <div class="choose-img-content">
              <div
                v-for="(item, index) in tabsContent[key].src"
                :key="index"
                class="img-content"
              >
                <TokenImage :imageUrl='imgUrl + item.path' :className="'downLoad-img'" :token='userToken' class="downLoad-img"/>
                <!-- <TokenImage v-if="isImgToken" :imageUrl='imgUrl + item.path' imageType="view" className="downLoad-img"/>
                <img v-else class="downLoad-img" :src="imgUrl + item.path" alt=""> -->
              </div>
            </div>
          </div>
        </div>
        <div class="li-content">
          <div class="border-style" @click="clickShows('showOther', 'otherImgPic')">
            <mt-cell class="title-weight" title="其他信息">
              <img :src="otherImgPic" alt="">
            </mt-cell>
          </div>
          <div v-show="showOther" class="info-content">
            <div class="info-li" v-if="channelName">
              <a href="#">渠道</a>
              <p>{{channelName}}</p>
            </div>
            <div v-if="network" class="info-li">
              <a href="#">网点编码</a>
              <p>{{ networkName }}</p>
            </div>
            <div
              v-if="network && userCode !== null && userCode !== ''"
              class="info-li"
            >
              <a href="#">介绍人工号</a>
              <p>{{ userCode }}</p>
            </div>
            <div
              v-if="
                network &&
                  introduceAgreementNo !== null &&
                  introduceAgreementNo !== ''
              "
              class="info-li"
            >
              <a href="#">代理协议号</a>
              <p>{{ introduceAgreementNo }}</p>
            </div>
            <div v-if="network" class="info-li">
              <a href="#">车队协议号</a>
              <p>{{ vehicleInfo.contractNo }}</p>
            </div>
            <div v-if="basePart.isDjqShow" class="info-li">
              <a href="#">是否真单交</a>
              <p>{{ basePart.isDjq }}</p>
            </div>
          </div>
        </div>

        <!-- 电子保单/批单 -->
        <div v-show="isshow" class="li-content">
          <div class="border-style" @click="clickShows('showShare', '')">
            <mt-cell class="title-weight" title="电子保单/批单">
              <button class="shareButton" @click="handleShare">
                分享
              </button>&ensp;&ensp;
              <img v-if="showShare" :src="imgAll + '/sales330709.png'" alt="">
              <img v-else :src="imgAll + '/sales310709.png'" alt="">
            </mt-cell>
          </div>
          <div v-show="showShare" class="info-content">
            <div>
              <p
                v-for="(item, index) in ePolicyDtoList"
                :key="index"
                class="info-share"
                style="margin-top: 0; color: #5e2589"
                @click="handleClick(item)"
              >
                {{ item.downLoadName }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showFoot" class="foot">
        <div class="foot-div">
          <div>
            <van-checkbox
              v-model="hadRead"
              checked-color="#f29600"
              @change="clickRead"
            />
          </div>
          <div style="margin-left:8px">
            我已阅读<span class="info-a" @click="goTiaoKuan">《机动车交通事故责任强制保险条款》</span>及<span class="info-a" @click="goTiShiShu">《机动车辆保险投保提示书》</span>及<span class="info-a" @click="goQZTiShi">《机动车交通事故责任强制保险投保提示书》</span>及<span class="info-a" @click="goShengMing">《投保人声明》</span>
          </div>
        </div>
        <div v-if="!isH5" class="next-step">
          <button v-if="!publics" class="save-btn" @click="share">
            分享支付
          </button>
          <button :class="publics ? 'save-zf' : ''" @click="goNext">
            支付
          </button>
        </div>
        <div v-else class="next-step" @click="goNext">
          <div class="pay-btn">
            支付
          </div>
        </div>
      </div>
      <div v-show="isPop" class="popbox" @click="isPop = false">
        <img :src="shouzhi" alt="" class="shouzhi">
        <div class="ptext">
          <p>点击右上角</p>
          <p>分享给微信好友</p>
        </div>
      </div>
      <Loading :switchs="switchs" />
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import api from '@/api/api.js'
// import sha1 from 'sha1';
// import { plus } from '@/utils/checkFormat.js'
import checkFormat from '@/utils/checkFormat.js'
import mathFn from '@/utils/math.js'
import Loading from '@/components/Loadings/Loading'
import TokenImage from '@/components/tokenImage'
import { removeWatermark, setWaterMark } from '../../watermark'
export default {
  components: {
    Loading: Loading,
    TokenImage
  },
  data() {
    return {
      orgBackground: '',
      cInfo: '',
      neworderPolicyList: [],
      showShare: true,
      networkName: '',
      userCode: '',
      introduceAgreementNo: '',
      showOpen: false, // 控制页面提示（安卓10兼容问题）
      add: 0,
      switchs: false,
      orderId: '',
      imgAll: api.imgAllUrl,
      deleteImg: api.imgAllUrl + '/sales240709.png',
      downImgOrder: api.imgAllUrl + '/sales330709.png',
      downImgFee: api.imgAllUrl + '/sales330709.png',
      downImgCar: api.imgAllUrl + '/sales330709.png',
      downImgPer1: api.imgAllUrl + '/sales330709.png',
      downImgPer2: api.imgAllUrl + '/sales330709.png',
      downImgPer3: api.imgAllUrl + '/sales330709.png',
      downImgPic: api.imgAllUrl + '/sales330709.png',
      enginShow: api.imgAllUrl + '/sales330709.png',
      downImgDeliv: api.imgAllUrl + '/sales330709.png',
      imgUrlIcon: api.imgAllUrl + '/sales400709.png',
      shouzhi: api.imgAllUrl + '/sales410723.png',
      shareLogo: api.imgAllUrl + '/wxLogo20210616.png',
      otherImgPic: api.imgAllUrl + '/sales330709.png',
      orderNo: '',
      orderPolicyList: {},
      orderAmount: '',
      // 车主
      carOwnerInfo: {
        carOwner: '', // 车主姓名
        ownerIdentifyType: '', // 证件类型
        ownerIdentifyNumber: '', // 证件号码
        mobile: '', //
        email: '', //
        ownerAddress: ''
      },
      // 投保人
      applicantIn: {
        insuredName: '',
        insuredIdentity: '',
        identifyNumber: '',
        mobile: '', //
        email: '', //
        address: '',
        linkerName: ''
      },
      // 被保人
      recognizeeIn: {
        insuredName: '',
        insuredIdentity: '',
        identifyNumber: '',
        mobile: '', //
        email: '', //
        address: '',
        linkerName: ''
      },
      deliveryInfo: {
        receivePhone: '',
        receiver: '',
        receiverAddress: '',
        receiverMail: ''
      },
      vehicleInfo: {
        engineNo: '',
        enrollDate: '',
        licenseNo: '',
        vINNo: '',
        brandName: ''
      },
      basePart: {
        isDjq: '', // 是否真单交---前提是只有交强险
        isDjqShow: false
      },
      tabsContent: [],
      bxInfo: [], // 商业险数据
      JQInfo: '', // 交强险数据
      hasDelivery: false,
      hasImglist: false,
      showOrder: true,
      showFee: true,
      showJQ: false,
      showSY: false,
      showJY: false,
      showJSR: true, // 驾驶人意外险是否显示
      showCar: true,
      hideArea1: true,
      hideArea2: true,
      hideArea3: true,
      showPic: true,
      showEngin: true,
      showOther: true,
      showDeliv: true,
      hadRead: false,
      isPop: false,
      showFoot: false,
      str: '', // 随机数
      JQDateS: '',
      JQHourS: '',
      JQDateE: '',
      JQHourE: '',
      SYDateS: '',
      SYHourS: '',
      SYDateE: '',
      SYHourE: '',
      SYOderNo: '', // 商业险投保单号
      JQOderNo: '', // 交强险投保单号
      JYOderNo: '', // 驾意险投保单号
      JSROderNo: '', // 驾驶人意外险投保单号
      SYPolicyNo: '',
      JQPolicyNo: '',
      JYPolicyNo: '',
      JSRPolicyNo: '',
      discount: '',
      planFee: '', // 商业险保费计算
      planFeeCi: '', // 交强险保费计算
      planFeeCs: '', // 车船税
      showXianXia: false,
      showXianShang: false,
      carPolicySubInfoList: [], // 核心产品-线下 页面展示列表
      attachRiskList: [], // 产品工厂产品-线上 页面展示列表
      scheme: {
        text: '',
        code: '',
        sumAmount: '0',
        sumPremium: '0',
        commiFee: '0',
        riskCode: ''
      },
      JSRScheme: {
        text: '',
        code: '',
        sumAmount: '0',
        sumPremium: '0',
        commiFee: '0',
        riskCode: ''
      },
      codecname: '', // 投保地区
      adds: [
        {
          index: '1',
          value: '正常缴税'
        },
        {
          index: '2',
          value: '免税'
        },
        {
          index: '3',
          value: '减税'
        },
        {
          index: '4',
          value: '完税'
        },
        {
          index: '5',
          value: '不征'
        }
      ],
      ePolicyDtoList: [],
      taxRelifFlag: '',
      devUrl: api.devUrl,
      publics: true,
      imgUrl: api.imgIdUrl,
      network: false,
      networks: false,
      channelCode: '', // 渠道
      channelName: '', // 其他渠道
      terminalId: '', // 从哪里进入待支付页的标记
      orderStatus: '',
      isshow: true,
      isH5: false,
      engageList: []
    }
  },
  watch: {
    add(value) {
      if (value > 0) {
        this.switchs = true
      } else {
        this.switchs = false
      }
    }
  },
  created() {
    this.getContentTabs()
    this.userToken = localStorage.getItem('setToken') || checkFormat.getUrlKey('token')
  },
  mounted() {
    console.log('mounted')
    // 从订单进入
    // if(this.$store.state.tab === '3'){
    //   let returnData = this.$store.state.orderIn
    //   this.xuanRan(returnData)
    // }
    // checkFormat.handleURLkey()
    const URL = window.location.href
    const receive = URL.split('?')[1].split('#')[0].split('&')
    console.log('this.$route', this.$route)
    this.terminalId = localStorage.getItem('setTerminalId')
    this.channelCode = localStorage.getItem('setChannelCode')
    if (this.channelCode === 'ZKICATM') {
      this.network = true
    }
    if (localStorage.getItem('setChannelCode') !== 'DP_OWXPA') {
      this.publics = false
    } else {
      this.publics = true
    }
    // let orderId = ''
    receive.forEach((value) => {
      // if (value.split('=')[0] === 'orderId') {
      //   orderId = value.split('=')[1]
      // }
      if (value.split('=')[0] === 'isH5') {
        if (value.split('=')[1] === '1') {
          this.isH5 = true
        }
      }
    })
    this.getURL()
    this.getMortorQuery()
    this.getRandom(16)
    this.getTicket()
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  activated() {
    console.log('activated')
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.$store.commit('setShow', false)
    // 从支付页面返回至此直接跳订单列表，因为无法获取orderId重新渲染该页面，存localStorage拿不到
    // if(localStorage.getItem('ZFSign')==='222' && this.$store.state.orderId===''){
    //   this.$router.push('/Order')
    // }
    // 从核保页面进入
    if (this.$route.query.tip === '1') {
      this.queryDetail(this.$store.state.orderId)
    }
    if (this.$route.query.isH5 === '1') {
      this.isH5 = true
    }
  },
  deactivated() {
    this.$store.commit('setShow', true)
  },
  destroyed() {
    removeWatermark()
  },
  methods: {
    getContentTabs() { // 影像信息数据
      const params = {
        codeType: 'DocumentsType'
      }
      this.switchs = true
      this.$http
        .post(api.getByCodeType, params)
        .then((res) => {
          this.switchs = false
          if (res.status === 200) {
            const imgTypeDatas = res.data
            this.tabsContent = []
            for (const item in imgTypeDatas) {
              imgTypeDatas[item].fileType = imgTypeDatas[item].codeCode
              imgTypeDatas[item].text = imgTypeDatas[item].codecname
              imgTypeDatas[item].state = false
              imgTypeDatas[item].show = false
              imgTypeDatas[item].active = false
              imgTypeDatas[item].src = []
              this.tabsContent.push(imgTypeDatas[item])
            }
          } else {
            this.$toast('获取影像排序失败')
          }
        })
        .catch((err) => {
          console.log(err)
          this.switchs = false
        })
    },
    getMortorQuery() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: '加载中',
        loadingType: 'spinner',
        mask: true
      })
      this.$http.post(api.queryOrderDetail + `?fileContentFlag=0&orderId=${this.$route.query.orderId}`)
        .then(resTwo => {
          Toast.clear()
          console.log(resTwo, 'resTwo')
          if (resTwo.data.rtnCode === '0000') {
            if (resTwo.data.rtnCode === '0000') {
              const returnData = resTwo.data.resultObj
              this.ePolicyDtoList = resTwo.data.resultObj.ePolicyDtoList
              this.xuanRan(returnData)
              if (returnData.orderStatus === '2') {
                this.showFoot = true
              }
            } else {
              this.$toast(resTwo.data.rtnMsg)
            }
          } else {
            this.$toast(resTwo.data.rtnMsg)
          }
        })
        .catch(err => {
          Toast.clear()
          console.log(err)
          // this.$toast('')
        })
    },
    handleShare() {
      const url = window.location.href
      if (url.indexOf('APP') !== -1) {
        // APP端分享
        this.isPop = false
        const shareTitle = this.vehicleInfo.licenseNo + ' 电子保单/批单'
        const shareUrl = `${process.env.API_HOST}/app/mall/car-proposal/#/car/ElectronicPolicy?orderId=${this.$route.query.orderId}&channelCode=${this.$route.query.channelCode}&terminalId=${this.$route.query.terminalId}&token=${localStorage.getItem('setToken')}`
        const param = {
          title: shareTitle,
          url: shareUrl
        }
        ShowShareBtn.postMessage(JSON.stringify(param))
      } else {
        // H5端分享
        this.isPop = true
        this.getWXElectronic()
      }
    },
    getWXElectronic() {
      const param = {
        url: window.location.href,
        wxType: '5'
      }
      console.log(param.url)
      this.$http.post(api.getWxTicket, param).then((res) => {
        wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: api.appId, // 必填，企业微信的corpID
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        })
        this.Eleshare()
      })
    },
    Eleshare() {
      const that = this
      const shareTitle = that.vehicleInfo.licenseNo + ' 电子保单/批单'
      const shareUrl = `${process.env.API_HOST}/app/mall/car-proposal/#/car/ElectronicPolicy?orderId=${this.orderId}&channelCode=${this.$route.query.channelCode}&terminalId=${this.$route.query.terminalId}&token=${localStorage.getItem('setToken')}`
      // let shareUrl =`http://localhost:8080/app/mall/car-proposal/#/car/ElectronicPolicy?orderId=${this.$route.query.orderId}&channelCode=${this.$route.query.channelCode}&terminalId=${this.$route.query.terminalId}`
      console.log(shareUrl, '//////////')
      wx.ready(function() {
        // 分享给好友
        wx.onMenuShareAppMessage({
          title: shareTitle, // 分享标题
          desc: '一诺紫金，共享价值', // 分享描述
          link: shareUrl, // 分享链接
          imgUrl: that.shareLogo, // 分享图标
          success: function() {},
          cancel: function() {}
        })
      })
    },
    // 下载PDF
    handleClick(item) {
      if (
        (this.$route.query.channelCode === 'DP_OWXPA' ||
           this.$route.query.channelCode === 'DP_WXMP') &&
         this.$route.query.terminalId === 'APP'
      ) {
        this.getZSBPDF(item)
      } else if (
        this.$route.query.channelCode === 'DP_WXMP' &&
         this.$route.query.terminalId === 'WXMP'
      ) {
        wx.miniProgram.navigateTo({
          url:
             '/pdf?url=' +
             encodeURIComponent(
               `${process.env.API_HOST}/${item.downLoad.substring(1)}`
             )
        })
      } else {
        window.open(`${process.env.API_HOST}/${item.downLoad.substring(1)}`)
        // window.open(`${api.projectHostUrl}/${item.downLoad.substring(1)}`)
      }
    },
    getZSBPDF(item) {
      const param = {
        title: item.downLoadName,
        url: `${process.env.API_HOST}/${item.downLoad.substring(1)}`
      }
      PreviewPDF.postMessage(JSON.stringify(param))
    },
    // GetQueryString(name) {
    //   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    //   const hashArr = window.location.hash.split('?')
    //   var arr = '?' + hashArr[hashArr.length - 1]
    //   var r = arr.substr(1).match(reg)
    //   if (r != null) return unescape(r[2]); return null
    // },

    queryDetail(param) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        message: '加载中',
        loadingType: 'spinner',
        mask: true
      })
      this.$http
        .post(api.queryOrderDetail + '?orderId=' + param + '&fileContentFlag=0')
        .then((res) => {
          Toast.clear()
          if (res.data.rtnCode === '0000') {
            const returnData = res.data
            this.xuanRan(returnData)
          } else {
            this.$toast(res.data.rtnMsg)
          }
        })
        .catch((error) => {
          Toast.clear()
          console.log(error)
        })
    },
    getURL() {
      const URL = window.location.href
      if (URL.indexOf('showOpenToast=true') !== -1) {
        this.showOpen = true
      } else {
        this.showOpen = false
      }
    },
    // 数据渲染
    xuanRan(returnData) {
      console.log(returnData, '===xuanRan=')
      let temp = 0
      returnData.insuredFeeList.forEach((item) => {
        temp += Number(item.premium)
      })
      this.planFee = temp.toFixed(2)

      this.orderNo = returnData.orderNo
      this.orderStatus = returnData.orderStatus
      this.orderId = returnData.orderId
      console.log(this.orderId, '-eeeeeeeeeeee')
      //  console.log(this.orderStatus,returnData)
      // 订单分享是否显示
      this.orderStatus === '4' ? (this.isshow = true) : (this.isshow = false)
      returnData.planList.forEach((item) => {
        this.orderAmount = mathFn.highPrecisionAdd(
          this.orderAmount,
          item.planFee
        )
        // console.log("this.orderAmount",this.orderAmount);
      })
      console.log(returnData.engageList, 'engageList')
      if (returnData.discount) {
        this.discount = returnData.discount
      }
      if ( returnData.engageList !== null && returnData.engageList.length > 0) {
        this.engageList = returnData.engageList
      }
      this.adds.forEach((value) => {
        if (returnData.taxRelifInfo) {
          if (value.index === returnData.taxRelifInfo.taxRelifFlag) {
            this.taxRelifFlag = value.value
          }
        }
      })
      let planFeeCs = 0
      returnData.planList.forEach((value) => {
        if (value.riskCode === 'CSTax') {
          planFeeCs = mathFn.highPrecisionAdd(planFeeCs, value.planFee)
          console.log(
            mathFn.highPrecisionAdd(planFeeCs, value.planFee),
            typeof value.planFee
          )
          this.planFeeCs = checkFormat.toDecimal2(value.planFee)
        }
        if (value.riskCode === '0590') {
          planFeeCs = mathFn.highPrecisionAdd(planFeeCs, value.planFee)
          // console.log(planFeeCs, 254)
          this.planFeeCi = checkFormat.toDecimal2(value.planFee)
        }
        if (value.riskCode === '0591') {
          planFeeCs = mathFn.highPrecisionAdd(planFeeCs, value.planFee)
          // console.log(planFeeCs, 254)
          this.planFeeCi = checkFormat.toDecimal2(value.planFee)
        }
        if (value.riskCode === '0501' || value.riskCode === '050A') {
          this.planFee = checkFormat.toDecimal2(value.planFee)
        }
      })
      // console.log(planFeeCs, 254)
      this.planFeeCi = checkFormat.toDecimal2(planFeeCs)
      this.orderPolicyList = returnData.orderPolicyList
      // console.log(returnData.orderPolicyList,'!!!!')
      for (const k in this.orderPolicyList) {
        if (
          this.orderPolicyList[k].typeCode === '050B' ||
           this.orderPolicyList[k].typeCode === '050A'
        ) {
          this.SYOderNo = this.orderPolicyList[k].insureNo
          this.SYPolicyNo = this.orderPolicyList[k].policyNo
        } else if (
          this.orderPolicyList[k].typeCode === '0590' ||
           this.orderPolicyList[k].typeCode === '0591'
        ) {
          this.JQOderNo = this.orderPolicyList[k].insureNo
          this.JQPolicyNo = this.orderPolicyList[k].policyNo
        }
        if (
          this.orderPolicyList[k].typeCode !== '050A' &&
           this.orderPolicyList[k].typeCode !== '0590' &&
           this.orderPolicyList[k].typeCode !== '0591' &&
           this.orderPolicyList[k].typeCode !== '050B'
        ) {
          this.neworderPolicyList.push(this.orderPolicyList[k])
        }
      }
      // 核心产品-线下
      if (
        returnData.carPolicySubInfoList !== null &&
         returnData.carPolicySubInfoList.length > 0
      ) {
        this.showXianXia = true
        returnData.carPolicySubInfoList.forEach((item) => {
          const obj = {
            productName: item.productName,
            planName: item.riskName,
            sumAmount: parseFloat(item.sumAmount / 10000).toFixed(2) + '万',
            sumPremium: parseFloat(item.sumPremium).toFixed(2)
          }
          this.carPolicySubInfoList.push(obj)
          this.orderAmount = mathFn.highPrecisionAdd(
            this.orderAmount,
            item.sumPremium
          )
        })
      }
      // 产品工厂产品-线上
      if (
        returnData.attachRiskList !== null &&
         returnData.attachRiskList.length > 0
      ) {
        this.showXianShang = true
        returnData.attachRiskList.forEach((item) => {
          const obj = {
            productName: item.productName,
            planName: item.planName,
            sumAmount: parseFloat(item.sumAmount / 10000).toFixed(2) + '万',
            sumPremium: parseFloat(item.sumPremium).toFixed(2)
          }
          this.attachRiskList.push(obj)
          this.orderAmount = mathFn.highPrecisionAdd(
            this.orderAmount,
            item.sumPremium
          )
        })
      }
      // 车主信息
      this.carOwnerInfo.carOwner = checkFormat.hideInsurantName(1, returnData.carOwnerInfo.carOwner)
      if (returnData.carOwnerInfo.ownerIdentifyType === '01') {
        this.carOwnerInfo.ownerIdentifyNumber = checkFormat.hideInsurantName(3, returnData.carOwnerInfo.ownerIdentifyNumber)
      } else {
        this.carOwnerInfo.ownerIdentifyNumber = checkFormat.hideInsurantName(5, returnData.carOwnerInfo.ownerIdentifyNumber, 1, 1)
      }
      this.carOwnerInfo.mobile = checkFormat.hideInsurantName(2, returnData.carOwnerInfo.mobile)
      this.carOwnerInfo.email = returnData.carOwnerInfo.email
      this.carOwnerInfo.ownerAddress = returnData.carOwnerInfo.ownerAddress
      // 车主身份类型
      // switch (returnData.carOwnerInfo.ownerIdentifyType) {
      //   case '01':
      //     this.carOwnerInfo.ownerIdentifyType = '身份证'
      //     break
      //   case '02':
      //     this.carOwnerInfo.ownerIdentifyType = '护照'
      //     break
      //   case '03':
      //     this.carOwnerInfo.ownerIdentifyType = '军人证'
      //     break
      //   case '10':
      //     this.carOwnerInfo.ownerIdentifyType = '组织机构代码'
      //     break
      //   case '11':
      //     this.carOwnerInfo.ownerIdentifyType = '工商注册号码'
      //     break
      // }
      const ownerIdentifyType = {
        '01': '身份证',
        '03': '护照',
        '04': '军人证',
        '10': '组织机构代码',
        '550': '港澳台居民居住证',
        '13': '统一社会信用代码',
        '41': '港澳通行证',
        '553': '外国人永久居留身份证',
        '511': '台湾居民来往大陆通行证',
      }
      // 投保与被投保validDate
      this.carOwnerInfo.ownerIdentifyType = ownerIdentifyType[returnData.carOwnerInfo.ownerIdentifyType]
      const insuredList = returnData.insuredList
      if (
        insuredList[0].insuredRelationship === '0' ||
        insuredList[0].insuredRelationship === '1' ||
        insuredList[0].insuredRelationship === '2'
      ) {
        this.applicantIn.insuredIdentity = ownerIdentifyType[insuredList[0].identifyType]
        this.recognizeeIn.insuredIdentity = ownerIdentifyType[insuredList[1].identifyType]
        this.applicantIn.insuredName = checkFormat.hideInsurantName(1, insuredList[0].insuredName)
        if (this.applicantIn.insuredIdentity === '身份证') {
          this.applicantIn.identifyNumber = checkFormat.hideInsurantName(3, insuredList[0].identifyNumber)
        } else {
          this.applicantIn.identifyNumber = checkFormat.hideInsurantName(5, insuredList[0].identifyNumber, 1, 1)
        }
        this.applicantIn.mobile = checkFormat.hideInsurantName(2, insuredList[0].mobile)
        this.recognizeeIn.insuredName = checkFormat.hideInsurantName(1, insuredList[1].insuredName)
        if (this.recognizeeIn.insuredIdentity === '身份证') {
          this.recognizeeIn.identifyNumber = checkFormat.hideInsurantName(3, insuredList[1].identifyNumber)
        } else {
          this.recognizeeIn.identifyNumber = checkFormat.hideInsurantName(5, insuredList[1].identifyNumber, 1, 1)
        }
        this.recognizeeIn.mobile = checkFormat.hideInsurantName(2, insuredList[1].mobile)
        this.applicantIn.email = insuredList[0].email
        this.applicantIn.address = insuredList[0].address
        this.applicantIn.validDate = insuredList[0].validDate
        this.recognizeeIn.validDate = insuredList[1].validDate
        this.recognizeeIn.email = insuredList[1].email
        this.recognizeeIn.address = insuredList[1].address
      } else {
        this.applicantIn.insuredIdentity = ownerIdentifyType[insuredList[1].identifyType]
        this.recognizeeIn.insuredIdentity = ownerIdentifyType[insuredList[0].identifyType]
        this.applicantIn.insuredName = checkFormat.hideInsurantName(1, insuredList[1].insuredName)
        if (this.applicantIn.insuredIdentity === '身份证') {
          this.applicantIn.identifyNumber = checkFormat.hideInsurantName(3, insuredList[1].identifyNumber)
        } else {
          this.applicantIn.identifyNumber = checkFormat.hideInsurantName(5, insuredList[1].identifyNumber, 1, 1)
        }
        this.applicantIn.mobile = checkFormat.hideInsurantName(2, insuredList[1].mobile)
        this.recognizeeIn.insuredName = checkFormat.hideInsurantName(1, insuredList[0].insuredName)
        if (this.recognizeeIn.insuredIdentity === '身份证') {
          this.recognizeeIn.identifyNumber = checkFormat.hideInsurantName(3, insuredList[0].identifyNumber)
        } else {
          this.recognizeeIn.identifyNumber = checkFormat.hideInsurantName(5, insuredList[0].identifyNumber, 1, 1)
        }
        this.recognizeeIn.mobile = checkFormat.hideInsurantName(2, insuredList[0].mobile)
        this.applicantIn.email = insuredList[1].email
        this.applicantIn.address = insuredList[1].address
        this.applicantIn.validDate = insuredList[1].validDate
        this.applicantIn.linkerName = insuredList[1].linkerName
        this.recognizeeIn.validDate = insuredList[0].validDate
        this.recognizeeIn.email = insuredList[0].email
        this.recognizeeIn.address = insuredList[0].address
        this.recognizeeIn.linkerName = insuredList[0].linkerName
      }
      if (this.recognizeeIn.validDate === '9999-12-31') {
        this.recognizeeIn.validDate = '长期'
      }
      if (this.applicantIn.validDate === '9999-12-31') {
        this.applicantIn.validDate = '长期'
      }

      // 影像信息
      if (
        returnData.itemFileDataList &&
         returnData.itemFileDataList[0] &&
         returnData.itemFileDataList[0].fileList !== null &&
         returnData.itemFileDataList[0].fileList.length > 0
      ) {
        this.hasImglist = true
        // console.log(this.tabsContent, 'this.tabsContent');
        const imageInfoList = returnData.itemFileDataList[0].fileList
        for (const i in imageInfoList) {
          // console.log(imageInfoList[i].fileId, 'fileIdfileId');
          const fileStreams = imageInfoList[i].fileId
          const obj = {
            path: fileStreams
          }
          for (const item in this.tabsContent) {
            if (Number(imageInfoList[i].fileType) === Number(this.tabsContent[item].codeCode)) {
              this.tabsContent[item].src.push(obj)
              this.tabsContent[item].state = true
              this.tabsContent[item].active = true
            }
          }
        }
      }
      // 车辆信息
      this.vehicleInfo.engineNo = returnData.vehicleInfo.engineNo
      this.vehicleInfo.enrollDate = returnData.vehicleInfo.enrollDate
      this.vehicleInfo.licenseNo = returnData.vehicleInfo.licenseNo
      this.vehicleInfo.vINNo = returnData.vehicleInfo.vINNo
      this.vehicleInfo.brandName = returnData.vehicleInfo.brandName
      this.vehicleInfo.insuredAreaCN = returnData.vehicleInfo.insuredAreaCN
      this.vehicleInfo.insuredArea = returnData.vehicleInfo.insuredArea
      this.vehicleInfo.contractNo = returnData.vehicleInfo.contractNo
      if (returnData.baseInfo.isDjq) {
        this.basePart.isDjq = returnData.baseInfo.isDjq === '0' ? '否' : '是'
        this.basePart.isDjqShow = true
      } else {
        this.basePart.isDjqShow = false
      }
      //其他渠道
      if (returnData.baseInfo && (returnData.baseInfo.businessNatureCN || returnData.baseInfo.channelName)) {
        this.channelName = returnData.baseInfo.businessNatureCN || returnData.baseInfo.channelName
      }
      // 保险信息
      // let bx = returnData.insuredFeeList
      const bx = returnData.insuredFeeListUnprocessed
      for (const j in bx) {
        if (bx[j].kindCode === 'BZ') {
          this.showJQ = true
          this.JQInfo = checkFormat.toDecimal2(bx[j].premium)
        } else {
          this.showSY = true
          checkFormat.toDecimal2(bx[j].premium)
          this.bxInfo.push(bx[j])
        }
      }
      this.bxInfo.forEach((item) => {
        const amountNum = Number(item.amount)
        let n = 10000
        let s = '万'
        const y = '元'
        if (amountNum < 10000 && amountNum > 1000) {
          n = 1000
          s = '千'
        } else if (amountNum < 1000 && amountNum > 0) {
          n = 100
          s = '百'
        } else if (amountNum > 10000) {
          n = 10000
          s = '万'
        } else {
          item.amountNumber = ''
        }
        if (amountNum) {
          const quantity = Math.round((amountNum / n) * 100) / 100
          if (quantity === parseInt(quantity)) {
            item.amountNumber = Math.round((amountNum / n) * 100) / 100 + s
          } else {
            item.amountNumber = amountNum + y
          }
        }
      })
      // 保险日期
      this.JQDateS = returnData.baseInfo.startDateCI
      this.JQHourS = returnData.baseInfo.startHourCI
      this.JQDateE = returnData.baseInfo.endDateCI
      this.JQHourE = returnData.baseInfo.endHourCI
      this.SYDateS = returnData.baseInfo.startDate
      this.SYHourS = returnData.baseInfo.startHour
      this.SYDateE = returnData.baseInfo.endDate
      this.SYHourE = returnData.baseInfo.endHour
      this.networkName = returnData.vehicleInfo.netWorkName
      this.userCode = returnData.baseInfo.introduceCode
      this.introduceAgreementNo = returnData.baseInfo.introduceAgreementNo
    },
    clickRead(event) {
      this.hadRead = event
    },
    // 获取随机数
    getrandNum() {
      const arrNum = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
      ]
      const randNum = Math.floor(Math.random() * 62)
      this.str += arrNum[randNum]
    },
    getRandom(num) {
      for (let i = 0; i < num; i++) {
        this.getrandNum()
      }
    },
    // 获取签名
    getTicket() {
      const param = {
        url: window.location.href,
        wxType: '5'
      }
      this.add += 1
      this.$http
        .post(api.getWxTicket, param)
        .then((res) => {
          wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: api.appId, // 必填，企业微信的corpID
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: ['onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
          })
          this.add = this.add - 1
        })
        .catch((error) => {
          console.log(error)
          this.add = this.add - 1
        })
      wx.error(function(res) {
        console.log(res)
        // alert('验证失败');
      })
    },
    // 分享
    share() {
      // 获取当前浏览器地址
      const appUrl = window.location.href
      const receive = `orderId=${this.orderId}&channelCode=${this.channelCode}&terminalId=${this.terminalId}&token=${localStorage.getItem('setToken')}`
      let shareUrl = appUrl.split('?')[0] + '?' + receive
      // 紫属保APP分享
      if (appUrl.indexOf('APP') !== -1) {
        const param = {
          title: '订单确认',
          url: shareUrl
        }
        ShowShareBtn.postMessage(JSON.stringify(param))
        // / 将紫属保app分享的判断逻辑值去除，这样二次分享不会走app的分享逻辑
        shareUrl = shareUrl.replace('terminalId=APP', '')
      } else {
        // H5端分享
        this.isPop = true
        const that = this
        wx.ready(function() {
          // 分享给好友
          wx.onMenuShareAppMessage({
            title: '订单确认', // 分享标题
            desc: '紫金保险销售有限公司移动展业平台', // 分享描述
            link: shareUrl, // 分享链接
            imgUrl: that.shareLogo, // 分享图标
            success: function() {},
            cancel: function() {}
          })
        })
      }
    },
    filtration(value) {
      return value < 10 ? '0' + value : value
    },
    // 支付
    goNext() {
      if (this.hadRead) {
        // window.location.href = `${api.projectHostUrl}/app/tools/#/queryPay?channelCode=${this.$route.query.channelCode}&terminalId=${this.$route.query.terminalId}&orderAmount=${this.orderAmount}&orderNo=${this.orderNo}`
        // console.log(this.orderPolicyList, 'this.orderPolicyList')
        const time = new Date()
        const Year = time.getFullYear()
        const Month = this.filtration(time.getMonth() + 1)
        const Dates = this.filtration(time.getDate())
        const Hours = this.filtration(time.getHours())
        const Minutes = this.filtration(time.getMinutes())
        const Seconds = this.filtration(time.getSeconds())
        let timeInfo = Year + '-' + Month + '-' + Dates + ' ' + Hours + ':' + Minutes + ':' + Seconds
        timeInfo = new Date(timeInfo).getTime()
        if (this.orderPolicyList && this.orderPolicyList.length > 0 && this.orderPolicyList[0].startDate) {
          const startDate = new Date(this.orderPolicyList[0].startDate).getTime()
          // console.log(startDate, timeInfo, '00000')
          if (startDate < timeInfo) {
            this.$toast('投保日期不能早于当前日期，请您重新投保')
            return
          } else {
            window.location.href = `${api.projectHostUrl}/app/tools/#/queryPay?channelCode=${this.$route.query.channelCode}&terminalId=${this.$route.query.terminalId}&orderAmount=${this.orderAmount}&orderId=${this.orderId}&token=${localStorage.getItem('setToken')}&orderNo=${this.orderNo}`
          }
        }
      } else {
        this.$toast('请先阅读《机动车交通事故责任强制保险条款》及《机动车辆保险投保提示书》及《机动车交通事故责任强制保险投保提示书》及《投保人声明》')
      }
    },
    // 折叠面板优化
    clickShows(showFlag, imgKey) {
      this[showFlag] = !this[showFlag]
      if (imgKey) {
        this[imgKey] = `${api.imgAllUrl}${
          this[showFlag] ? '/sales330709.png' : '/sales310709.png'
        }`
      }
    },
    goTiaoKuan() {
      window.open('https://open.zking.com/cms/uploads/15/product/html/zsb_vehicle_clause.html')
    },
    goTiShiShu() {
      window.open('https://open.zking.com/cms/uploads/15/product/html/zsb_insurance_reminder.html')
    },
    goQZTiShi() {
      window.open('https://open.zking.com/cms/uploads/15/product/html/zsb_reminder_insurance.html')
    },
    goShengMing() {
      window.open('https://open.zking.com/cms/uploads/15/product/html/zsb_policy_declaration.html')
    }
  }
}
</script>
 <style lang="scss" scoped>
 @import "./affirmMessage.scss";
 </style>




// WEBPACK FOOTER //
// src/pages/motor/components/confirm/confirm.vue